import { render, staticRenderFns } from "./merList.vue?vue&type=template&id=0005c5ad&scoped=true&"
import script from "./merList.vue?vue&type=script&lang=js&"
export * from "./merList.vue?vue&type=script&lang=js&"
import style0 from "./merList.vue?vue&type=style&index=0&id=0005c5ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005c5ad",
  null
  
)

export default component.exports